export default {
    namespaced: true,

    state: {
        reCaptcha: {
            siteKey: '6Lfin6MZAAAAAFzgnGuWDRi4_L7WvirWeil2QPya'
        }
    },

    getters: {
        //
    },

    mutations: {
        //
    },

    actions: {
        //
    }
}
